import React, { useEffect, useRef } from 'react';
import { XAiProviderProps } from '@/types/XAiProvider';
import XAiProvider from '@/components/XAiProvider';
import XAiChatbot from '@/components/XAiChatbot';

export interface UseXAiSDKOptions extends XAiProviderProps {
  containerId?: string;
  width?: string | number;
  height?: string | number;
  className?: string;
  style?: React.CSSProperties;
}

export const useXAiSDK = (options: UseXAiSDKOptions) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const {
    containerId = 'xai-chatbot-container',
    width = '400px',
    height = '600px',
    className,
    style,
    ...providerProps
  } = options;

  useEffect(() => {
    if (containerRef.current) {
      // 确保容器存在
      const container = containerRef.current;
      if (!container.querySelector('.xai-chatbot-wrapper')) {
        // 创建包装器
        const wrapper = document.createElement('div');
        wrapper.className = 'xai-chatbot-wrapper';
        wrapper.style.width = typeof width === 'number' ? `${width}px` : width;
        wrapper.style.height = typeof height === 'number' ? `${height}px` : height;
        if (className) wrapper.className += ` ${className}`;
        if (style) Object.assign(wrapper.style, style);
        
        container.appendChild(wrapper);
      }
    }
  }, [containerId, width, height, className, style]);

  return {
    containerRef,
    render: () => (
      <div ref={containerRef} id={containerId}>
        <XAiProvider {...providerProps}>
          <XAiChatbot />
        </XAiProvider>
      </div>
    ),
  };
};

export default useXAiSDK; 